// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"70":"13899081ecad088ea6f4","125":"73222d9981faa8e018c4","223":"08c88331d1df99287f55","242":"b3b4b66facea76ff799e","293":"ec01416971dd6461d686","556":"d45205c46ad4aec2c17b"}[chunkId] + ".js";
};